import published from './published'

export default class Pager<T> {
  private page = 0
  private pageSize: number

  public completed = published<boolean>(false)
  public items = published<T[]>([])

  public constructor(pageSize: number) {
    this.pageSize = pageSize
  }

  public load = async (factory: (page: number) => Promise<T[]>) => {
    if (this.completed.value) {
      return
    }
    const newItems = await factory(this.page)
    this.completed.publish(newItems.length < this.pageSize)
    this.page += 1
    this.items.reduce((items) => items.concat(newItems))
  }
}
